import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_b19tidse3g: FaireBrandEntity = {
  token: "b_b19tidse3g",
  type: "brand",
  name: "BOTANICA",
  avatarUrl:
    "https://cdn.faire.com/fastly/b20f41529b7625b596630968b69fa718417826a33c04966d18b97456efa9b06d.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/31668db96802732ef7ef79fb2e3a67797128cc0df14fe3ae75141ffd51efb04f.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/b20f41529b7625b596630968b69fa718417826a33c04966d18b97456efa9b06d.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/31668db96802732ef7ef79fb2e3a67797128cc0df14fe3ae75141ffd51efb04f.jpeg",
  location: "Vero Beach, FL, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 136,
  isTopShop: true,
  isInsider: true,
  description:
    "Botanica is a boutique manufacturer of candles, incense, perfume, & coordinating home products. By utilizing the highest quality of ingredients & materials, they aim to produce luxurious products customers feel good using themselves, as well as purchasing for friends and family. In addition to ethical production practices, Botanica simultaneously contributes a portion of profits to charities across the globe. In these efforts, they hope to work together toward the goal of ecological, societal, and environmental sustainability. \n\nBotanica gives back $1 from every Signature Candle sold to non-profits regions indigenous to the candle's fragrance inspiration. Learn more about their partners on the back of each Signature Candle.\n\n\nCandles poured in Vero Beach, FL & Los Angeles, CA",
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:06:22.755Z",
    importedBy: "entity-db-cli",
  },
};
